import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { MaterialsModule } from './materials.module';
import { LoginService } from './login/login.service';
import { LoginGuard } from './login/login.guard';
import { LoginInterceptor } from './login/login.interceptor';
import { PublisherComponent } from './publisher/publisher.component';
import { LoginManisesComponent } from './login-manises/login-manises.component';
import { HomeManisesComponent } from './home-manises/home-manises.component';
import { LoginGinemedComponent } from './login-ginemed/login-ginemed.component';
import { HomeGinemedComponent } from './home-ginemed/home-ginemed.component';
import { LoginHVDMComponent } from './login-hvdm/login-hvdm.component';
import { HomeHVDMComponent } from './home-hvdm/home-hvdm.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    PublisherComponent,
    LoginManisesComponent,
    HomeManisesComponent,
    LoginGinemedComponent,
    HomeGinemedComponent,
    LoginHVDMComponent,
    HomeHVDMComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialsModule,
    ReactiveFormsModule, 
    FormsModule,
    HttpClientModule
  ],
  providers: [
    LoginService,
    LoginGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoginInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
